import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';
import { useLanguage } from '../../../../Context/LanguageContext';

import MemberShipHistoryColumn from './MemberShipHistoryColumn.js';
import MemberShipHistoryInfoView from './MemberShipHistoryInfoView.js';
import CourseHistoryColumnView from './CourseHistoryColumnView.js';
import CourseHistoryInfoView from './CourseHistoryInfoView.js';
import LockerHistoryColumnView from './LockerHistoryColumnView.js';
import LockerHistoryInfoView from './LockerHistoryInfoView.js';
import InfoPagination from '../../../../Component/MemberComponent/InfoPagination.js';

// import Modal //
import PaymentModal from '../PaymentModal.js';
import MemberShipAddModal from './Modal/MemberShipAddModal.js';
import MemberShipEditModal from './Modal/MemberShipEditModal.js';
import MemberShipDeleteModal from './Modal/MemberShipDeleteModal.js';
import MemberShipHoldingModal from './Modal/MemberShipHoldingModal.js';
import MemberShipExtendModal from './Modal/MemberShipExtensionModal.js';
import RefundModal from './Modal/RefundModal.js';
import LockerRefundModal from './Modal/LockerRefundModal.js';

import FetchModule from '../../../Share/Network/FetchModule.js';

import { ReactComponent as PlusSvg } from '../../../../image/Plus.svg';
import HoldingHistoryColumn from './HoldingHistoryColumn.js';
import HoldingHistoryInfoView from './HoldingHistoryInfoView.js';
import HoldingCancelModal from './Modal/HoldingCancelModal.js';
import HoldingDeleteModal from './Modal/HoldingDeleteModal.js';
import HoldingAndExtendsDetailModal from './Modal/HoldingAndExtendsDetailModal.js';
import MemberShipHoldingEditModal from './Modal/MemberShipHoldingEditModal.js';
import MemberShipExtendModifyModal from './Modal/MemberShipExtendModifyModal.js';
import MemberShipExtendDeleteModal from './Modal/MemberShipExtendDeleteModal.js';
import LockerUsageAddModal from './Modal/LockerUsageAddModal.js';
import LockerExtendsModal from '../../LockerModel/LockerExtendsModal.js';
import LockerUsageStopModal from './Modal/LockerUsageStopModal.js';
import CourseHistoryAddModal from './Modal/CourseHistoryAddModal.js';
import ProductSalesAddModal from './Modal/ProductSalesAddModal.js';
import ProductPaymentModal from './Modal/ProductPaymentModal.js';
import ProductUsageColumn from './ProductUsageColumn.js';
import ProductUsageInfoView from './ProductUsageInfoView.js';
import ProductSalesDeleteModal from './Modal/ProductSalesDeleteModal.js';
import MemberShipRefundDeleteModal from './Modal/MemberShipRefundDeleteModal.js';
import AttendanceRateBox from './AttendanceRateBox.js';
import TotalAttendanceCountBox from './TotalAttendanceCountBox.js';
import AttendanceCalenderBox from './AttendanceCalenderBox.js';
import LockerUsageModifyModal from './Modal/LockerUsageModifyModal.js';
import WaitingPagePaymentModal from '../WaitingPagePaymentModal.js';
import MemberShipRegistrationPaymentModal from '../MemberShipRegistrationPaymentModal.js';
import ExpectedUsageDeleteModal from './Modal/ExpectedUsageDeleteModal.js';
import ExpectedLockerDeleteModal from './Modal/ExpectedLockerDeleteModal.js';
import SubscriptionColumnView from './SubscriptionColumnView.js';
import ExtendAddModal from './Modal/ExtendAddModal.js';
import PointSaveModal from './Modal/PointSaveModal.js';
import PointHistoryColumn from './PointHistoryColumn.js';
import PointHistoryInfo from '../PointHistoryInfo.js';
import PointHistoryDeleteModal from './Modal/PointHistoryDeleteModal.js';
import MembershipSubscriptionCancelModal from './Modal/MembershipSubscriptionCancelModal.js';
import FailedSubscriptMembershipInfoView from './FailedSubscriptMembershipInfoView.js';
import MembershipPaymentModal from './Modal/MembershipPaymentModal.js';
import SubscriptionRetryModal from './Modal/SubscriptionRetryModal.js';
import LockerUsageHistoryDeleteModal from './Modal/LockerUsageHistoryDeleteModal.js';
import LockerRefundDeleteModal from './Modal/LockerRefundDeleteModal.js';

const HistoryView = forwardRef((props, ref) => {
  const {
    memberId,
    memberData,
    storeName,
    memberShipData,
    holdingData,
    failedSubscriptMemberships,
    division,
    lessonHistoryData,
    physicalData,
    lockerData,
    productUsages,
    setProductUsages,
    totalPoint,
    pointHistories,
    rendering,
    lockerRendering
  } = props;

  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, isEng } = useLanguage();

  const [nowPage, setNowPage] = useState('MemberShip');
  const [index, setIndex] = useState(-1);
  const [clickedUsageId, setClickedUsageId] = useState(undefined);
  const [clickedMembershipName, setClickedMembershipName] = useState('');

  const [isUsePaymentSystem, setIsUsePaymentSystem] = useState(false);

  const [refundData, setRefundData] = useState(null);
  const [holdingMemberShipData, setHoldingMemberShipData] = useState(undefined);
  const [holdingEditData, setHoldingEditData] = useState(undefined);
  const [holdingDeleteData, setHoldingDeleteData] = useState(undefined);

  const [userData, setUserData] = useState(undefined);

  const [isInProgressMerchant, setIsInProgressMerchant] = useState(false);
  const [isInProgressUsage, setIsInProgressUsage] = useState(false);

  const [productName, setProductName] = useState('');
  const [productCoach, setProductCoach] = useState('');
  const [productValidity, setProductValidity] = useState(0);
  const [productPrice, setProductPrice] = useState(0);
  const [productCash, setProductCash] = useState(0);
  const [productDiscountPrice, setProductDiscountPrice] = useState(0);
  const [productNotReceivedPrice, setProductNotReceivedPrice] = useState(0);
  const [productPoint, setProductPoint] = useState(0);
  const [productMerchantUid, setProductMerchantUid] = useState('');
  const [productCount, setProductCount] = useState(0);

  const [totalRegistData, setTotalRegistData] = useState(undefined);

  const [isClickedPayment, setIsClickedPayment] = useState(false);
  const [isClickedProductPayment, setIsClickedProductPayment] = useState(false);
  const [isClickedAddMemberShip, setIsClickedAddMemberShip] = useState(false);
  const [isClickedModify, setIsClickedModify] = useState(false);
  const [isClickedHolding, setIsClickedHolding] = useState(false);
  const [isClickedRefund, setIsClickedRefund] = useState(false);
  const [isClickedExtension, setIsClickedExtension] = useState(false);
  const [isClickedSubscriptionCancel, setIsClickedSubscriptionCancel] = useState(false);
  const [isClickedDelete, setIsClickedDelete] = useState(false);

  const [isClickedEditMembership, setIsClickedEditMembership] = useState(false);
  const [isClickedSubscriptionRetry, setIsClickedSubscriptionRetry] = useState(false);
  const [selectedFailedMembership, setSelectedFailedMembership] = useState(undefined);

  const [isClickedRefundDelete, setIsClickedRefundDelete] = useState(false);

  const [isClickedAddProduct, setIsClickedAddProduct] = useState(false);
  const [isClickedProductForm, setIsClickedProductForm] = useState(false);
  const [selectedProductData, setSelectedProductData] = useState(undefined);
  const [isClickedDeleteProduct, setIsClickedDeleteProduct] = useState(false);

  const [isClickedAddCourse, setIsClickedAddCourse] = useState(false);

  const [isClickedHoldingEdit, setIsClickedHoldingEdit] = useState(false);
  const [isClickedHoldingCancel, setIsClickedHoldingCancel] = useState(false);
  const [isClickedHoldingDelete, setIsClickedHoldingDelete] = useState(false);
  const [isClickedHoldingDetail, setIsClickedHoldingDetail] = useState(false);
  const [isClickedModifyExtend, setIsClickedModifyExtend] = useState(false);
  const [isClickedDeleteExtend, setIsClickedDeleteExtend] = useState(false);
  const [isClickedStartLocker, setIsClickedStartLocker] = useState(false);
  const [isClickedExtendsLocker, setIsClickedExtendsLocker] = useState(false);
  const [isClickedStopLocker, setIsClickedStopLocker] = useState(false);
  const [isClickedRefundLocker, setIsClickedRefundLocker] = useState(false);
  const [lockerRefundData, setLockerRefundData] = useState(null);
  const [isClickedDeleteLockerUsageHistory, setIsClickedDeleteLockerUsageHistory] = useState(false);
  const [isClickedDeleteLockerRefund, setIsClickedDeleteLockerRefund] = useState(false);
  const [clickLockerRefundData, setClickLockerRefundData] = useState(undefined);
  const [isClickedModifyLocker, setIsClickedModifyLocker] = useState(false);
  const [isClickedDeleteExpectedUsage, setIsClickedDeleteExpectedUsage] = useState(false);
  const [isClickedDeleteExpectedLocker, setIsClickedDeleteExpectedLocker] = useState(false);
  const [isClickedEditPoint, setIsClickedEditPoint] = useState(false);
  const [isClickedDeletePoint, setIsClickedDeletePoint] = useState(false);

  const [isLoadingPoint, setIsLoadingPoint] = useState(false);

  const [isExtend, setIsExtend] = useState(false);
  const [clickHoldingAndExtendData, setClickHoldingAndExtendData] = useState(undefined);
  const [selectedEditMembership, setSelectedEditMembership] = useState(undefined);
  const [clickLockerData, setClickLockerData] = useState(undefined);
  const [clickProductData, setClickProductData] = useState(undefined);
  const [clickRefundData, setClickRefundData] = useState(undefined);
  const [clickExpectedData, setClickExpectedData] = useState(undefined);
  const [clickExpectedLockerData, setClickExpectedLockerData] = useState(undefined);
  const [clickedPointHistory, setClickedPointHistory] = useState(undefined);

  const [memberPage, setMemberPage] = useState(0);
  const [reservePage, setReservePage] = useState(0);
  const [lockerPage, setLockerPage] = useState(0);
  const [pointHistoryPage, setPointHistoryPage] = useState(0);
  const [useMemberShips, setUseMemberShips] = useState([]);
  const [useReserve, setUseReserve] = useState([]);
  const [useLocker, setUseLocker] = useState([]);
  const [usePointHistories, setUsePointHistories] = useState([]);

  const [firstExpiredIndex, setFirstExpiredIndex] = useState(-1);

  const MemberShipAddModalRef = useRef();
  const AddButtonRef = useRef();
  const MemberShipRef = useRef();
  const CourseRef = useRef();
  const LockerRef = useRef();
  const HoldingRef = useRef();
  const PaginationRef = useRef();
  const HistoryButtonRef = useRef();
  const FailedHistoryButtonRef = useRef();
  const ProductModalRef = useRef();

  useEffect(() => {
    if (division === 'locker') setNowPage('Locker');
    else if (division === 'holding') setNowPage('Holding');
    else if (division === 'course') setNowPage('Course');
  }, [division])

  function getButtonText() {
    if (nowPage === 'MemberShip') return t('memberDetail.addMembership');
    else if (nowPage === 'Course') return t('memberDetail.addCourse');
    else if (nowPage === 'Product') return t('memberDetail.addProduct');
    else if (nowPage === 'Locker') return t('memberDetail.addLocker');
    else if (nowPage === 'Point') return t('memberDetail.addPoint');
    return '';
  }

  useEffect(() => {
    if (nowPage === 'MemberShip') {
      AddButtonRef.current.style.opacity = 1;
      AddButtonRef.current.style.zIndex = 1;
      AddButtonRef.current.style.width = isEng ? '121px' : '103px';
    }
    else if (nowPage === 'Course') {
      AddButtonRef.current.style.opacity = 1;
      AddButtonRef.current.style.zIndex = 1;
      AddButtonRef.current.style.width = isEng ? '120px' : '118px';
    }
    else if (nowPage === 'Product') {
      AddButtonRef.current.style.opacity = 1;
      AddButtonRef.current.style.zIndex = 1;
      AddButtonRef.current.style.width = isEng ? '70px' : '118px';
    }
    else if (nowPage === 'Coach') {
      AddButtonRef.current.style.opacity = 0;
      AddButtonRef.current.style.zIndex = -1;
      AddButtonRef.current.style.width = isEng ? '135px' : '103px';
    }
    else if (nowPage === 'Locker') {
      AddButtonRef.current.style.opacity = 1;
      AddButtonRef.current.style.zIndex = 1;
      AddButtonRef.current.style.width = isEng ? '80px' : '103px';
    }
    else if (nowPage === 'Holding') {
      AddButtonRef.current.style.opacity = 0;
      AddButtonRef.current.style.zIndex = -1;
      AddButtonRef.current.style.width = isEng ? '135px' : '103px';
    }
    else if (nowPage === 'Point') {
      AddButtonRef.current.style.opacity = 1;
      AddButtonRef.current.style.zIndex = 1;
      AddButtonRef.current.style.width = isEng ? '68px' : '103px';
    }
  }, [nowPage, isEng])

  useEffect(() => {
    let requestData = {
      memberId: memberId
    }

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postData('member/recently', 'POST', requestData);
        
        if (responseData.status === 200) {
          setUserData(responseData.data[0]);
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          history.push('/');
        }
      }
    )();
  }, [])

  // 링크페이 사용여부 확인하기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getIndividualData('store/check/linkpay', 'GET');

        if (responseData.status === 200) setIsUsePaymentSystem(responseData.data[0]);
      }
    )();
  }, [])

  // 컬럼 페이지네이션 //
  useEffect(() => {
    const newUseMemberships = memberShipData.slice((memberPage * 10), (memberPage * 10) + 10);
    let newFirstExpiredIndex = -1;

    newUseMemberships.map((data, index) => {
      if (data.isExpired && newFirstExpiredIndex === -1) {
        newFirstExpiredIndex = index;
      }
    });

    setFirstExpiredIndex(newFirstExpiredIndex === 0 ? -1 : newFirstExpiredIndex);
    setUseMemberShips(newUseMemberships);
  }, [memberShipData, memberPage])

  // 컬럼 페이지네이션 //
  useEffect(() => {
    setUseReserve(lessonHistoryData.slice(reservePage * 5, (reservePage * 5) + 5));
  }, [lessonHistoryData, reservePage])

  // 컬럼 페이지네이션 //
  useEffect(() => {
    const sorted = [...lockerData].sort((a, b) => (b.isPending ? 1 : 0) - (a.isPending ? 1 : 0));
    setUseLocker(sorted.slice(lockerPage * 10, (lockerPage * 10) + 10));
  }, [lockerData, lockerPage])

  // 컬럼 페이지네이션 //
  useEffect(() => {
    setUsePointHistories(pointHistories.slice(pointHistoryPage * 10, (pointHistoryPage * 10) + 10));
  }, [pointHistories, pointHistoryPage])

  function memberShipModifyClick(index) {
    setSelectedEditMembership(useMemberShips[index]);
    setIsClickedEditMembership(true);
  }

  // 구독형 회원권 재결제 요청 버튼 클릭시
  function onClickSubscriptionRetry(index) {
    setSelectedFailedMembership(failedSubscriptMemberships[index]);
    setIsClickedSubscriptionRetry(true);
  }

  // 구독형 회원권 재결제 모달 닫기
  function onClickExitSubscriptionRetry() {
    setIsClickedSubscriptionRetry(false);
    setSelectedFailedMembership(undefined);
  }

  // 회원권 홀딩 버튼 클릭시
  function memberShipHoldingClick(index) {
    setIsClickedHolding(!isClickedHolding);
    setIndex(index);
  }

  function memberShipExtensionClick(index) {
    setIsClickedExtension(!isClickedExtension);
    setIsExtend(true);
    setIndex(index);
    setClickedUsageId(memberShipData[index].usageId);
    setClickedMembershipName(memberShipData[index].memberShipName);
  }

  function memberShipDeleteClick(index) {
    // 링크 페이의 경우 //
    if (memberShipData[index].merchantUid.split('-')[2] === '1' || memberShipData[index].merchantUid.split('-')[2] === '2') {
      alert(t('memberDetail.alertLinkpayDelete'));
      return;
    }
    // 링크페이가 아닌경우 //
    else {
      setIsClickedDelete(!isClickedDelete);
      setIndex(index);
    }
  }

  // 회원권 추가 수정 모달에서 닫기 버튼 클릭시 //
  function onClickExitEditMembershipModal() {
    setIsClickedEditMembership(false);
    setSelectedEditMembership(undefined);
    setIndex(-1);
    rendering();
  }

  function exitClick(className) {
    if (className === 'Modify') setIsClickedModify(false);
    else if (className === 'Holding') setIsClickedHolding(false);
    else if (className === 'Extension') {
      setIsExtend(false);
      setIsClickedExtension(false);
      setIndex(-1);
      setClickedUsageId(undefined);
      setClickedMembershipName('');
    }
    else if (className === 'Delete') setIsClickedDelete(false);

    setIndex(-1);
    rendering();
  }

  function onClickExtendsExit() {
    setIsExtend(false);
    setIsClickedExtension(false);
    setClickedUsageId(undefined);
    setClickedMembershipName('');
    setIndex(-1);
    rendering();
  }

  function onClickAddMemberShipOrLockerButton() {
    if (nowPage === 'MemberShip') setIsClickedEditMembership(true);
    else if (nowPage === 'Locker') setIsClickedStartLocker(true);
    else if (nowPage === 'Course') setIsClickedAddCourse(true);
    else if (nowPage === 'Product') setIsClickedAddProduct(true);
    else if (nowPage === 'Point') setIsClickedEditPoint(true);
  }

  function onClickHoldingEdit(data) {
    for (let i = 0; i < memberShipData.length; i++) {
      if (memberShipData[i].usageId === data.usageId) {
        setHoldingMemberShipData(memberShipData[i]);
        break;
      }
    }

    setHoldingEditData(data);
    setIsClickedHoldingEdit(true);
  }

  function onClickHoldingEditExit() {
    setIsClickedHoldingEdit(false);
    setHoldingEditData(undefined);
    setHoldingMemberShipData(undefined);
  }

  // 회원권 홀딩 내역 삭제 버튼 클릭시 //
  function onClickDeleteHoldingHistory(data) {
    setHoldingDeleteData(data);
    setIsClickedHoldingDelete(true);
  }

  // 홀딩 내역 삭제를 진행하지 않을경우 //
  function onClickHoldingDeleteExit() {
    setHoldingDeleteData(undefined);
    setIsClickedHoldingDelete(false);
  }

  function onClickRefundButton(index) {
    const merchantList = useMemberShips[index].merchantUids.split(',');
    const lastMerchantUid = merchantList[merchantList.length - 1];
    
    setRefundData({
      membershipName: useMemberShips[index].memberShipName,
      cardPrice: useMemberShips[index].cardPrice,
      cashPrice: useMemberShips[index].cashPrice,
      totalPrice: useMemberShips[index].price,
      selectedPaymentOptions: useMemberShips[index].selectedPaymentOptions,
      merchantUid: lastMerchantUid,
      approvalDate: useMemberShips[index].approvalDate
    });
    setIsClickedRefund(true);
  }

  // 구독형 회원권 구독 해지 클릭시 //
  function onClickSubscriptionCancel(index) {
    setIsClickedSubscriptionCancel(!isClickedSubscriptionCancel);
    setIndex(index);
  }

  // 회원권 홀딩 또는 연장 자세히 보기 버튼 클릭 //
  function onClickHoldingAndExtendButton(data) {
    setClickHoldingAndExtendData(data);
    setIsClickedHoldingDetail(true);
  }

  function onRegist() {
    let memberShipData = MemberShipAddModalRef.current.getMemberShipData();
    let cardPrice = MemberShipAddModalRef.current.getCardPrice();
    let cashPrice = MemberShipAddModalRef.current.getCashPrice();
    let discountPrice = MemberShipAddModalRef.current.getDiscountPrice();
    let notReceivedPrice = MemberShipAddModalRef.current.getNotReceivedPrice();
    let point = MemberShipAddModalRef.current.getPoint();

    if (memberShipData.name === '선택') {
      alert(t('memberDetail.alertSelectMembership'));
      return;
    }
    else if (parseInt(point.toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
      alert(t('memberDetail.alertPointExceeded'));
      return;
    }
    else if (cardPrice + cashPrice + discountPrice + point === 0) {
      let answer = window.confirm(t('memberDetail.confirmNoPayment'));

      if (answer) {
      }
      else {
        return;
      }
    }

    let requestData = {
      itemName: memberShipData.name,
      cashPrice: cashPrice,
      cardPrice: cardPrice,
      discountPrice: discountPrice,
      notReceivedPrice: notReceivedPrice,
      point: point,
      storeId: window.sessionStorage.getItem('StoreId'),
      memberId: parseInt(memberId),
      status: 0
    }

    if (isInProgressMerchant) return;

    setIsInProgressMerchant(true);

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postData('sales/merchant', 'POST', requestData);

        if (responseData.status === 200) {
          setProductName(responseData.data[0].itemName);
          setProductCoach('');
          setProductValidity(memberShipData.validity);
          setProductPrice(responseData.data[0].cardPrice);
          setProductCash(responseData.data[0].cashPrice);
          setProductDiscountPrice(responseData.data[0].discountPrice);
          setProductNotReceivedPrice(responseData.data[0].notReceivedPrice);
          setProductPoint(responseData.data[0].point);
          setProductMerchantUid(responseData.data[0].merchantUid);
          setProductCount(1);

          let storeId = window.sessionStorage.getItem('StoreId');
          let memberShipId = MemberShipAddModalRef.current.getMemberShipId();
          let cardPrice = MemberShipAddModalRef.current.getCardPrice();
          let cashPrice = MemberShipAddModalRef.current.getCashPrice();
          let discountPrice = MemberShipAddModalRef.current.getDiscountPrice();
          let notReceivedPrice = MemberShipAddModalRef.current.getNotReceivedPrice();
          let startDate = MemberShipAddModalRef.current.getStartDate().replaceAll('.', '-') + 'T00:00:00';
          let endDate = MemberShipAddModalRef.current.getEndDate().replaceAll('.', '-') + 'T23:59:59';
          let approvalDate = MemberShipAddModalRef.current.getApprovalDate().replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss');
          let totalMax = MemberShipAddModalRef.current.getTotalMax();

          let data = {
            storeId: parseInt(storeId),
            memberId: parseInt(memberId),
            memberShipId: memberShipId,
            merchantUid: responseData.data[0].merchantUid,
            courseTakeCount: 0,
            cardPrice: cardPrice,
            cashPrice: cashPrice,
            discountPrice: discountPrice,
            notReceivedPrice: notReceivedPrice,
            point: point,
            startDate: startDate,
            endDate: endDate,
            approvalDate: approvalDate,
            totalMax: totalMax
          }

          setTotalRegistData(data);
          setIsClickedPayment(true);
          setIsInProgressMerchant(false);
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          history.push('/');
        }
        else {
          setIsInProgressMerchant(false);
        }
      }
    )();
  }

  function onRegistForProduct() {
    if (clickProductData === undefined) {
      let productData = ProductModalRef.current.getProductData();
      let discountPrice = ProductModalRef.current.getDiscountPrice();
      let notReceivedPrice = ProductModalRef.current.getNotReceivedPrice();
      let count = ProductModalRef.current.getCount();
      
      let selectedPaymentOptions = ProductModalRef.current.getSelectedPaymentOptions();
      let finalCashPrice = 0;
      let finalCardPrice = 0;
      let finalPoint = 0;

      let finalSelectedPaymentOptions = [];

      for (let i = 0; i < selectedPaymentOptions.length; i++) {
        if (selectedPaymentOptions[i].price !== ''
          && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
      }

      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].id === 0) {
          if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '카드' || finalSelectedPaymentOptions[i].name === '링코페이') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        }
      }

      if (productData === undefined) {
        alert(t('memberDetail.productSalesModal.alertSelectProduct'));
        return;
      }
      else if (count === 0) {
        alert(t('memberDetail.productSalesModal.alertSetProductCount'));
        return;
      }
      else if (parseInt(finalPoint.toString().replaceAll(',', '')) > 0 && parseInt(finalPoint.toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
        alert(t('memberDetail.alertPointExceeded'));
        return;
      }
      else if (finalCashPrice + finalCardPrice + discountPrice + discountPrice + finalPoint === 0
        && finalSelectedPaymentOptions.reduce((sum, opt) => sum + parseInt(opt.price || 0), 0) === 0) {
        let answer = window.confirm(t('memberDetail.confirmNoPayment'));

        if (answer) {
        }
        else {
          return;
        }
      }


      let requestData = {
        registrationType: 'ADD_PRODUCT',
        memberId: parseInt(memberId),
        storeId: parseInt(window.sessionStorage.getItem('StoreId')),
        product: {
          productId: ProductModalRef.current.getProductId(),
          count: parseInt(count),
          productCardPrice: finalCardPrice,
          productCashPrice: finalCashPrice,
          productDiscountPrice: parseInt(discountPrice.toString().replaceAll(',', '')),
          productPoint: finalPoint,
          productPaymentOptions: finalSelectedPaymentOptions
        }
      }

      if (isInProgressMerchant) return;

      setIsInProgressMerchant(true);
      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('member/enroll', 'POST', requestData);
          if (responseData.status === 200) {
            alert(t('memberDetail.productSalesModal.alertProductPurchaseComplete'));
            setIsClickedAddProduct(false);
            setIsClickedProductForm(false);
            setSelectedProductData(undefined);
            rendering();
            setIsInProgressMerchant(false);
          }
          else if (responseData.status === 201) {
            alert(t('memberDetail.productSalesModal.alertOutOfStock'));
            setIsInProgressMerchant(false);
          }
          else if (responseData.status === 401) {
            alert(t('memberDetail.alertLoginRetry'));
            history.push('/');
          }
          else {
            setIsInProgressMerchant(false);
          }
        }
      )();
    }
    else {
      let storeId = window.sessionStorage.getItem('StoreId');
      const productData = ProductModalRef.current.getProductData();
      let productId = ProductModalRef.current.getProductId();
      let discountPrice = ProductModalRef.current.getDiscountPrice();
      let notReceivedPrice = ProductModalRef.current.getNotReceivedPrice();
      let count = ProductModalRef.current.getCount();

      let selectedPaymentOptions = ProductModalRef.current.getSelectedPaymentOptions();
      let finalCashPrice = 0;
      let finalCardPrice = 0;
      let finalPoint = 0;

      let finalSelectedPaymentOptions = [];

      for (let i = 0; i < selectedPaymentOptions.length; i++) {
        if (selectedPaymentOptions[i].price !== ''
          && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
      }

      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].paymentOptionId === 0) {
          if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        }
      }

      if (parseInt(finalPoint.toString().replaceAll(',', '')) > 0 && parseInt(finalPoint.toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
        alert(t('memberDetail.alertPointExceeded'));
        return;
      }

      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].paymentOptionId === undefined) {
          finalSelectedPaymentOptions[i].paymentOptionId = finalSelectedPaymentOptions[i].id;
          finalSelectedPaymentOptions[i].id = 0;
        }
        finalSelectedPaymentOptions[i].paymentOptionName = finalSelectedPaymentOptions[i].name;
      }

      const indicator = clickProductData.merchantUid?.split('-')[2];
      const isUnpaidLinkoPayCase = indicator === '1';
      const isLinkPayPaid = indicator === '2';
      const isLinkoPayActive = finalSelectedPaymentOptions.some(opt => opt.name === '링코페이');
      const isTypeChanging =
        (!isLinkPayPaid && !isUnpaidLinkoPayCase && isLinkoPayActive) ||
        isUnpaidLinkoPayCase ||
        (isLinkPayPaid && !isLinkoPayActive);

      if (isTypeChanging) {
        const sourceType = isUnpaidLinkoPayCase ? 'EXPECTED' : 'USAGE';
        const sourceId = isUnpaidLinkoPayCase
          ? (clickProductData.expectedUsageId ?? clickProductData.usageId)
          : clickProductData.usageId;
        const targetType = isLinkoPayActive ? 'LINKO_PAY' : 'ON_SITE';

        let changeCardPrice = 0;
        let changeCashPrice = 0;
        let changePoint = 0;
        for (const opt of finalSelectedPaymentOptions) {
          const price = parseInt((opt.price || 0).toString().replaceAll(',', ''));
          if (opt.name === '카드' || opt.name === '링코페이') changeCardPrice += price;
          else if (opt.name === '현금') changeCashPrice += price;
          else if (opt.name === '포인트') changePoint += price;
        }

        const changePaymentData = {
          sourceType,
          sourceId,
          targetType,
          merchantUid: clickProductData.merchantUid,
          storeId: parseInt(storeId),
          memberId: parseInt(memberId),
          productId,
          count: parseInt(count),
          cardPrice: changeCardPrice,
          cashPrice: changeCashPrice,
          discountPrice: parseInt(discountPrice.toString().replaceAll(',', '')),
          notReceivedPrice: parseInt(notReceivedPrice.toString().replaceAll(',', '')),
          point: changePoint,
          approvalDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          selectedPaymentOptions: finalSelectedPaymentOptions
        };

        if (isInProgressMerchant) return;
        setIsInProgressMerchant(true);

        const fetchModule = new FetchModule();
        (async () => {
          const responseData = await fetchModule.postDataVersion2('product/usage/change-payment', 'POST', changePaymentData);

          if (responseData.status === 200) {
            alert(t('memberDetail.productSalesModal.alertProductModifyComplete'));
            setIsClickedAddProduct(false);
            setIsClickedProductForm(false);
            setSelectedProductData(undefined);
            rendering();
            setClickProductData(undefined);
            setIsInProgressMerchant(false);
          }
          else if (responseData.status === 401) {
            setIsInProgressMerchant(false);
          }
          else {
            setIsInProgressMerchant(false);
          }
        })();
        return;
      }

      let data = {
        id: clickProductData.usageId,
        storeId: parseInt(storeId),
        memberId: parseInt(memberId),
        productId: productId,
        itemName: productData.name,
        merchantUid: clickProductData.merchantUid,
        cardPrice: finalCardPrice,
        cashPrice: finalCashPrice,
        discountPrice: parseInt(discountPrice.toString().replaceAll(',', '')),
        notReceivedPrice: parseInt(notReceivedPrice.toString().replaceAll(',', '')),
        point: finalPoint,
        count: count,
        selectedPaymentOptions: finalSelectedPaymentOptions
      }

      if (isInProgressMerchant) return;

      setIsInProgressMerchant(true);

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postData('product/usage/modify', 'POST', data);

          if (responseData.status === 200) {
            alert(t('memberDetail.productSalesModal.alertProductModifyComplete'));
            setIsClickedAddProduct(false);
            setIsClickedProductForm(false);
            setSelectedProductData(undefined);
            rendering();
            setClickProductData(undefined);
            setIsInProgressMerchant(false);
          }
          else if (responseData.status === 201) {
            alert(t('memberDetail.productSalesModal.alertOutOfStock'));
            setIsInProgressMerchant(false);
            return;
          }
          else if (responseData.status === 401) {
            alert(t('memberDetail.alertLoginRequired'));
            history.push('/');
          }
          else {
            setIsInProgressMerchant(false);
          }
        }
      )();
    }
  }

  function cancelFunction(merchantUid) {
    let storeId = window.sessionStorage.getItem('StoreId');
    let memberShipId = MemberShipAddModalRef.current.getMemberShipId();
    let cardPrice = MemberShipAddModalRef.current.getCardPrice();
    let cashPrice = MemberShipAddModalRef.current.getCashPrice();
    let discountPrice = MemberShipAddModalRef.current.getDiscountPrice();
    let notReceivedPrice = MemberShipAddModalRef.current.getNotReceivedPrice();
    let point = MemberShipAddModalRef.current.getPoint();
    let startDate = MemberShipAddModalRef.current.getStartDate().replaceAll('.', '-') + 'T00:00:00';
    let endDate = MemberShipAddModalRef.current.getEndDate().replaceAll('.', '-') + 'T23:59:59';
    let approvalDate = MemberShipAddModalRef.current.getApprovalDate().replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss');
    const totalMax = MemberShipAddModalRef.current.getTotalMax();

    let data = {
      storeId: parseInt(storeId),
      memberId: parseInt(memberId),
      memberShipId: memberShipId,
      merchantUid: merchantUid,
      courseTakeCount: 0,
      cardPrice: cardPrice,
      cashPrice: cashPrice,
      discountPrice: discountPrice,
      notReceivedPrice: notReceivedPrice,
      point: point,
      startDate: startDate,
      endDate: endDate,
      approvalDate: approvalDate,
      totalMax: totalMax
    }

    if (isInProgressUsage) return;

    setIsInProgressUsage(true);

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postData('membership/usage', 'POST', data);

        if (responseData.status === 200) {
          alert(t('memberDetail.alertRegistComplete'));
          setIsClickedAddMemberShip(false);
          setIsInProgressUsage(false);
          rendering();
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRequired'));
          history.push('/');
        }
        else {
          setIsInProgressUsage(false);
        }
      }
    )();

    setIsClickedPayment(false);
    setIsExtend(false);
  }

  // 링크페이로 회원권 결제 요청 완료시 //
  function onCompleteExpectedLinkpay() {
    alert(t('memberDetail.alertRegistComplete'));
    setIsClickedPayment(false);
    setIsClickedAddMemberShip(false);
    rendering();
  }

  function cancelFunctionForProduct(merchantUid) {
    let storeId = window.sessionStorage.getItem('StoreId');
    let productId = ProductModalRef.current.getProductId();
    let discountPrice = ProductModalRef.current.getDiscountPrice();
    let notReceivedPrice = ProductModalRef.current.getNotReceivedPrice();
    let count = ProductModalRef.current.getCount();
    let approvalDate = moment().format('YYYY-MM-DDTHH:mm:ss');

      
    const selectedPaymentOptions = ProductModalRef.current.getSelectedPaymentOptions();
    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    const finalSelectedPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }

    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      if (finalSelectedPaymentOptions[i].id === 0) {
        if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }
    }

    let data = {
      id: -1,
      storeId: parseInt(storeId),
      memberId: parseInt(memberId),
      productId: productId,
      merchantUid: merchantUid,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      discountPrice: discountPrice,
      notReceivedPrice: notReceivedPrice,
      point: finalPoint,
      count: count,
      approvalDate: approvalDate,
    }

    if (isInProgressUsage) return;

    setIsInProgressUsage(true);

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postData('product/usage/save', 'POST', data);

        if (responseData.status === 200) {
          alert(t('memberDetail.productSalesModal.alertProductPurchaseComplete'));
          setIsClickedAddProduct(false);
          setIsClickedProductForm(false);
          setSelectedProductData(undefined);
          setIsInProgressUsage(false);
          rendering();
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRequired'));
          history.push('/');
        }
        else {
          setIsInProgressUsage(false);
        }
      }
    )();

    setIsClickedProductPayment(false);
    setIsExtend(false);
  }

  function saveRegistData(merchantUid) {
    let storeId = window.sessionStorage.getItem('StoreId');
    const memberShipId = MemberShipAddModalRef.current.getMemberShipId();
    let cardPrice = MemberShipAddModalRef.current.getCardPrice();
    let cashPrice = MemberShipAddModalRef.current.getCashPrice();
    let point = MemberShipAddModalRef.current.getPoint();
    const startDate = MemberShipAddModalRef.current.getStartDate().replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss');
    const endDate = MemberShipAddModalRef.current.getEndDate().replaceAll('.', '-') + 'T23:59:59';
    let approvalDate = MemberShipAddModalRef.current.getApprovalDate().replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss');

    let data = {
      storeId: parseInt(storeId),
      memberId: parseInt(memberId),
      memberShipId: memberShipId,
      merchantUid: merchantUid,
      courseTakeCount: 0,
      cardPrice: cardPrice,
      cashPrice: cashPrice,
      point: point,
      startDate: startDate,
      endDate: endDate,
      approvalDate: approvalDate
    }

    window.sessionStorage.setItem("RegistData", 'None');
    window.sessionStorage.setItem("UsageData", JSON.stringify(data));
  }

  function saveRegistDataForProduct(merchantUid) {
    const storeId = window.sessionStorage.getItem('StoreId');
    const productId = ProductModalRef.current.getProductId();
    const cardPrice = ProductModalRef.current.getCardPrice();
    let cashPrice = ProductModalRef.current.getCashPrice();
    const discountPrice = ProductModalRef.current.getDiscountPrice();
    const notReceivedPrice = ProductModalRef.current.getNotReceivedPrice();
    let point = ProductModalRef.current.getPoint();
    let count = ProductModalRef.current.getCount();
    const approvalDate = moment().format('YYYY-MM-DDTHH:mm:ss');

    let data = {
      storeId: parseInt(storeId),
      memberId: parseInt(memberId),
      productId: productId,
      merchantUid: merchantUid,
      cardPrice: cardPrice,
      cashPrice: cashPrice,
      discountPrice: discountPrice,
      notReceivedPrice: notReceivedPrice,
      point: point,
      count: count,
      approvalDate: approvalDate
    }

    window.sessionStorage.setItem("ProductRegistData", 'None');
    window.sessionStorage.setItem("ProductUsageData", JSON.stringify(data));
  }

  // 연장 내역 수정 클릭시 //
  function onClickModifyExtend(data) {
    setClickHoldingAndExtendData(data);
    setIsClickedModifyExtend(true);
  }

  // 연장 내역 수정 완료 또는 닫기 클릭시 //
  function onClickModifyExit() {
    setIsClickedModifyExtend(false);
    rendering();
  }

  // 연장 내역 삭제 클릭시 //
  function onClickDeleteExtend(data) {
    setClickHoldingAndExtendData(data);
    setIsClickedDeleteExtend(true);
  }

  // 연장내역 삭제 완료 또는 닫기 클릭시 //
  function onClickDeleteExit() {
    setIsClickedDeleteExtend(false);
    rendering();
  }

  // 회원권 환불 내역 삭제 클릭시 //
  function onClickRefundDelete(data) {
    setClickRefundData(data);
    setIsClickedRefundDelete(true);
  }

  // 락커 연장 클릭시 //
  function onClickLockerExtends(data) {
    setClickLockerData(data);
    setIsClickedExtendsLocker(true);
  }

  // 락커 사용종료 클릭시 //
  function onClickLockerExit(data) {
    setClickLockerData(data)
    setIsClickedStopLocker(true);
  }

  // 락커 환불 클릭시 //
  function onClickLockerRefund(data) {
    setLockerRefundData({
      membershipName: data.lockerName,
      cardPrice: data.cardPrice,
      cashPrice: data.cashPrice,
      totalPrice: data.totalPrice,
      selectedPaymentOptions: data.selectedPaymentOptions,
      merchantUid: data.merchantUid,
      approvalDate: data.approvalDate
    });
    setIsClickedRefundLocker(true);
  }

  // 락커 정보 수정 클릭시 //
  function onClickLockerModify(data) {
    setClickLockerData(data);
    setIsClickedStartLocker(true);
  }

  // 락커 정보 수정 닫기 클릭시 //
  function onClickExitLockerModify() {
    setClickLockerData(undefined);
    setIsClickedStartLocker(false);
  }

  // 락커 사용내역 삭제 클릭시 //
  function onClickDeleteLockerUsageHistory(data) {
    setClickLockerData(data);
    setIsClickedDeleteLockerUsageHistory(true);
  }

  // 경고모달 내에서 락커 사용내역 삭제 클릭시 //
  function onClickDeleteLockerUsageHistoryInModal() {
    if (clickLockerData === undefined) return;
    
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/history/delete/' + clickLockerData.usageId, 'POST');

        if (responseData.status === 200) {
          lockerRendering();
          setIsClickedDeleteLockerUsageHistory(false);
          alert(t('memberDetail.alertHistoryDeleteComplete'));
        }
      }
    )();
  }

  // 락커 사용내역 삭제 경고모달 닫기 클릭시 //
  function onClickExitDeleteLockerUsageHistoryModal() {
    setClickLockerData(undefined);
    setIsClickedDeleteLockerUsageHistory(false);
  }

  // 락커 환불 수정 클릭시 //
  function onClickModifyLockerRefund(data) {
    setLockerRefundData({
      membershipName: data.lockerName,
      cardPrice: data.cardPrice,
      cashPrice: data.cashPrice,
      totalPrice: data.totalPrice,
      selectedPaymentOptions: data.selectedPaymentOptions,
      merchantUid: data.merchantUid,
      approvalDate: data.approvalDate
    });
    setIsClickedRefundLocker(true);
  }

  // 락커 환불 삭제 클릭시 //
  function onClickDeleteLockerRefund(data) {
    setClickLockerRefundData(data);
    setIsClickedDeleteLockerRefund(true);
  }

  // 락커 환불 삭제 모달 닫기 클릭시 //
  function onClickExitDeleteLockerRefundModal() {
    setClickLockerRefundData(undefined);
    setIsClickedDeleteLockerRefund(false);
  }

  // 링크페이로 결제 요청한 내역 삭제 클릭시 //
  function onClickDeleteExpectedUsage(data) {
    setClickExpectedData(data);
    setIsClickedDeleteExpectedUsage(true);
  }

  // 사용 내역 연장 모달 내에서 저장하기 버튼 클릭시 //
  function onClickSaveExtends(endDate, cardPrice, cashPrice) {

    if (moment().clone().format('YYYY-MM-DDTHH:mm:ss') > endDate.clone().format('YYYY-MM-DDTHH:mm:ss')) {
      alert('사용 날짜 변경은 금일 보다 이전일 수 없습니다.');
      return;
    }

    let requestData = {
      lockerId: clickLockerData.lockerId,
      usageId: clickLockerData.usageId,
      endDate: endDate.clone().format('YYYY-MM-DDT23:59:59'),
      merchantUid: clickLockerData.merchantUid,
      cardPrice: parseInt(cardPrice.toString().replaceAll(',', '')),
      cashPrice: parseInt(cashPrice.toString().replaceAll(',', ''))
    }

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postData('locker/extend', 'POST', requestData);

        if (responseData.status === 200) {
          alert('변경이 완료되었습니다.');
          lockerRendering();
          setIsClickedExtendsLocker(false);
        }
      }
    )();
  }

  // 회원권 페이지네이션 다음 클릭시 //
  function onClickMemberNextPage() {
    if (Math.ceil(memberShipData.length / 10) > (memberPage + 1)) setMemberPage(memberPage + 1);
  }

  // 회원권 페이지네이션 이전 클릭시 //
  function onClickMemberPrevPage() {
    if (memberPage > 0) setMemberPage(memberPage - 1);
  }

  // 출석내역 페이지네이션 다음 클릭시 //
  function onClickReserveNextPage() {
    if (Math.ceil(lessonHistoryData.length / 5) > (reservePage + 1)) setReservePage(reservePage + 1);
  }

  // 출석내역 페이지네이션 이전 클릭시 //
  function onClickReservePrevPage() {
    if (reservePage > 0) setReservePage(reservePage - 1);
  }

  // 락커 페이지네이션 다음 클릭시 //
  function onClickLockerNextPage() {
    if (Math.ceil(lockerData.length / 10) > (lockerPage + 1)) setLockerPage(lockerPage + 1);
  }

  // 락커 페이지네이션 이전 클릭시 //
  function onClickLockerPrevPage() {
    if (lockerPage > 0) setLockerPage(lockerPage - 1);
  }

  // 포인트 페이지네이션 다음 클릭시 //
  function onClickPointHistoryNextPage() {
    if (Math.ceil(pointHistories.length / 10) > (pointHistoryPage + 1)) setPointHistoryPage(pointHistoryPage + 1);
  }

  // 포인트 페이지네이션 이전 클릭시 //
  function onClickPointHistoryPrevPage() {
    if (pointHistoryPage > 0) setPointHistoryPage(pointHistoryPage - 1);
  }

  function getApprovalDate() {
    return MemberShipAddModalRef.current.getApprovalDate().replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss');
  }

  function getApprovalDateForProduct() {
    return moment().format('YYYY-MM-DDTHH:mm:ss');
  }

  // 물품 구입 모달 닫기 버튼 클릭시 //
  function onClickExitAddProduct() {
    setIsClickedAddProduct(false);
    setClickProductData(undefined);
  }

  // 상품 선택 모달에서 상품 선택시 //
  function onSelectProduct(data) {
    setSelectedProductData(data);
    setIsClickedAddProduct(false);
    setIsClickedProductForm(true);
  }

  // 결제 폼 모달 닫기 버튼 클릭시 //
  function onClickExitProductForm() {
    setIsClickedProductForm(false);
    setClickProductData(undefined);
    setSelectedProductData(undefined);
  }

  // 물품 내역 변경 클릭시 //
  function onClickEditProductUsage(data) {
    setClickProductData(data);
    setIsClickedProductForm(true);
  }

  // 물품 내역 삭제 클릭시 //
  function onClickDeleteProductUsage(data) {
    setClickProductData(data);
    setIsClickedDeleteProduct(true);
  }

  // 물품 내역 삭제 모달에서 삭제하기 클릭시 //
  function onClickDeleteYesProductUsage() {

    let requestData = {
      storeId: window.sessionStorage.getItem('StoreId'),
      productUsageId: clickProductData.usageId,
      merchantUid: clickProductData.merchantUid,
    }

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postData('product/usage/delete', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('memberDetail.alertDeleteComplete'));
          setClickProductData(undefined);
          setIsClickedDeleteProduct(false);
          rendering();
        }
      }
    )();
  }

  // 물품 내역 삭제 모달에서 취소 클릭시 //
  function onClickDeleteExitProductUsage() {
    setClickProductData(undefined);
    setIsClickedDeleteProduct(false);
  }

  // 구매요청 내역 삭제 성공시 //
  function onSuccessDeletedExpectedUsage() {
    setClickExpectedData(undefined);
    setIsClickedDeleteExpectedUsage(false);
    rendering();
    lockerRendering();
  }

  // 락커 링코페이 결제요청 내역 삭제 클릭시 //
  function onClickDeleteExpectedLocker(data) {
    setClickExpectedLockerData(data);
    setIsClickedDeleteExpectedLocker(true);
  }

  // 락커 링코페이 결제요청 내역 삭제 성공시 //
  function onSuccessDeletedExpectedLocker() {
    setClickExpectedLockerData(undefined);
    setIsClickedDeleteExpectedLocker(false);
    lockerRendering();
  }


  // 포인트 추가 및 변경 저장 //
  function onClickPointHistorySave(memberId, pointHistoryId, point, approvalDate, reason) {
    if (isLoadingPoint) {
      alert(t('memberDetail.alertPointSaving'));
      return;
    }

    setIsLoadingPoint(true);

    const requestData = {
      pointHistoryId: pointHistoryId,
      memberId: memberId,
      point: point,
      approvalDate: approvalDate,
      reason: reason
    }

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('point/save', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('memberDetail.alertPointSaveComplete'));
          setClickedPointHistory(undefined);
          setIsLoadingPoint(false);
          setIsClickedEditPoint(false);
          rendering();
        }
        else {
          setIsLoadingPoint(false);
        }
      }
    )();
  }

  // 포인트 수정하기 클릭시 //
  function onClickModifyPoint(data) {
    setClickedPointHistory(data);
    setIsClickedEditPoint(true);
  }

  // 포인트 삭제하기 클릭시 //
  function onClickDeletePoint(data) {
    setClickedPointHistory(data);
    setIsClickedDeletePoint(true);
  }

  // 포인트 추가 및 수정 모달 닫기 클릭시 //
  function onClickExitEditPointHistoryModal() {
    setClickedPointHistory(undefined);
    setIsClickedEditPoint(false);
  }

  // 포인트 삭제 모달 닫기 클릭시 //
  function onClickedExitDeletePointHistoryModal() {
    setClickedPointHistory(undefined);
    setIsClickedDeletePoint(false);
  }

  return (
    <TopLevelWrapper>
      <ModalThemeBridge>
      {
        isClickedPayment &&
        <MemberShipRegistrationPaymentModal
          isUsePaymentSystem={isUsePaymentSystem}
          name={productName}
          validity={productValidity}
          price={productPrice}
          cashPrice={productCash}
          discount={productDiscountPrice}
          notReceived={productNotReceivedPrice}
          point={productPoint}
          merchantUid={productMerchantUid}
          count={productCount}
          totalRegistData={totalRegistData}
          onRegist={cancelFunction}
          onCompleteExpectedLinkpay={onCompleteExpectedLinkpay}
          cancel={() => setIsClickedPayment(false)}
          saveRegistData={saveRegistData}
          getApprovalDate={getApprovalDate} />
      }
      {
        isClickedProductPayment &&
        <PaymentModal
          isUsePaymentSystem={isUsePaymentSystem}
          name={productName}
          validity={productValidity}
          price={productPrice}
          cashPrice={productCash}
          discount={productDiscountPrice}
          notReceived={productNotReceivedPrice}
          merchantUid={productMerchantUid}
          count={productCount}
          onRegist={cancelFunctionForProduct}
          cancel={() => setIsClickedProductPayment(false)}
          saveRegistData={saveRegistDataForProduct}
          getApprovalDate={getApprovalDateForProduct} />

      }
      {isClickedEditMembership && <MembershipPaymentModal memberId={memberId} memberName={memberData.name} totalPoint={totalPoint} recentlyMembership={userData} selectedEditMembership={selectedEditMembership} onClickExit={onClickExitEditMembershipModal}/> }
      {isClickedAddMemberShip && <MemberShipAddModal ref={MemberShipAddModalRef} totalPoint={totalPoint} userData={userData} isExtend={isExtend} data={memberShipData} index={index} registerClick={onRegist} cancel={() => setIsClickedAddMemberShip(false)} />}
      {isClickedModify && <MemberShipEditModal className='Modify' memberId={memberId} data={memberShipData} totalPoint={totalPoint} userData={userData} index={index} exitClickFn={exitClick} />}
      {isClickedHolding && <MemberShipHoldingModal className='Holding' memberName={memberData.name} data={memberShipData} index={index} exitClickFn={exitClick} />}
      {isClickedRefund && <RefundModal refundData={refundData} memberName={memberData.name} storeName={storeName} rendering={rendering} exitClick={() => setIsClickedRefund(false)} />}

      {isClickedDelete && <MemberShipDeleteModal className='Delete' data={memberShipData} index={index} exitClickFn={exitClick} rendering={rendering} />}

      {isClickedAddCourse && <CourseHistoryAddModal memberId={memberId} memberName={memberData.name} rendering={rendering} onClickClose={() => setIsClickedAddCourse(false)} />}
      {isClickedSubscriptionCancel && <MembershipSubscriptionCancelModal memberName={memberData.name} data={memberShipData} index={index} rendering={rendering} onClickClose={() => setIsClickedSubscriptionCancel(false)} />}
      {isClickedSubscriptionRetry && <SubscriptionRetryModal memberId={memberId} memberName={memberData.name} data={selectedFailedMembership} rendering={rendering} onClickExit={onClickExitSubscriptionRetry} />}
      {isClickedRefundDelete && <MemberShipRefundDeleteModal data={clickRefundData} rendering={rendering} onClickExit={() => setIsClickedRefundDelete(false)} />}


      {/* 연장 */}
      {isClickedExtension && <ExtendAddModal memberData={memberData} usageId={clickedUsageId} membershipName={clickedMembershipName} onClickExit={onClickExtendsExit} />}
      {isClickedModifyExtend && <MemberShipExtendModifyModal data={clickHoldingAndExtendData} onClickExit={onClickModifyExit} />}
      {isClickedDeleteExtend && <MemberShipExtendDeleteModal data={clickHoldingAndExtendData} onClickExit={onClickDeleteExit} />}
      {/* 연장 */}

      {/* 홀딩 */}
      {isClickedHoldingEdit && <MemberShipHoldingEditModal data={holdingEditData} memberShipData={holdingMemberShipData} exitClickFn={onClickHoldingEditExit} rendering={rendering} />}
      {isClickedHoldingDelete && <HoldingDeleteModal data={holdingDeleteData} exitClickFn={onClickHoldingDeleteExit} rendering={rendering} />}
      {isClickedHoldingDetail && <HoldingAndExtendsDetailModal data={clickHoldingAndExtendData} closeFn={() => setIsClickedHoldingDetail(false)} />}
      {/* 홀딩 */}

      {/* 락커 */}
      {isClickedStartLocker && <LockerUsageAddModal memberData={memberData} recentlyMembership={userData} memberName={memberData.name} clickLockerData={clickLockerData} totalPoint={totalPoint} lockerRendering={lockerRendering} onClickExit={onClickExitLockerModify} />}
      {isClickedExtendsLocker && <LockerExtendsModal memberData={memberData} recentlyMembership={userData} lockerData={clickLockerData} lockerRendering={lockerRendering} closeFn={() => setIsClickedExtendsLocker(false)} />}
      {isClickedStopLocker && <LockerUsageStopModal data={clickLockerData} lockerRendering={lockerRendering} onClickExit={() => setIsClickedStopLocker(false)} />}
      {isClickedRefundLocker && <LockerRefundModal refundData={lockerRefundData} memberName={memberData.name} rendering={lockerRendering} exitClick={() => setIsClickedRefundLocker(false)} />}
      {isClickedDeleteLockerUsageHistory && <LockerUsageHistoryDeleteModal onClickExit={onClickExitDeleteLockerUsageHistoryModal} onClickDelete={onClickDeleteLockerUsageHistoryInModal} />}
      {isClickedDeleteLockerRefund && <LockerRefundDeleteModal data={clickLockerRefundData} rendering={lockerRendering} onClickExit={onClickExitDeleteLockerRefundModal} />}
      {isClickedDeleteExpectedLocker && <ExpectedLockerDeleteModal data={clickExpectedLockerData} onSuccess={onSuccessDeletedExpectedLocker} onClickExit={() => setIsClickedDeleteExpectedLocker(false)} />}
      {/* 락커 */}

      {/* 물품 구입 모달 */}
      {isClickedAddProduct && <ProductSalesAddModal onSelectProduct={onSelectProduct} onClickExit={onClickExitAddProduct} />}
      {isClickedProductForm && <ProductPaymentModal ref={ProductModalRef} clickData={selectedProductData} clickUsageData={clickProductData} memberName={memberData?.name} totalPoint={totalPoint} onRegist={onRegistForProduct} onClickExit={onClickExitProductForm} />}
      {isClickedDeleteProduct && <ProductSalesDeleteModal deleteClickFn={onClickDeleteYesProductUsage} exitClickFn={onClickDeleteExitProductUsage} />}
      {/* 물품 구입 모달 */}

      {/* 포인트 */}
      {isClickedEditPoint && <PointSaveModal memberData={memberData} clickedPointHistory={clickedPointHistory} onClickSave={onClickPointHistorySave} onClickExit={onClickExitEditPointHistoryModal} />}
      {isClickedDeletePoint && <PointHistoryDeleteModal data={clickedPointHistory} rendering={rendering} onClickExit={onClickedExitDeletePointHistoryModal} />}
      {/* 포인트 */}

      {/* 링크페이 결제 요청 내역 삭제 모달 */}
      {isClickedDeleteExpectedUsage && <ExpectedUsageDeleteModal data={clickExpectedData} onSuccess={onSuccessDeletedExpectedUsage} onClickExit={() => setIsClickedDeleteExpectedUsage(false)} />}
      {/* 링크페이 결제 요청 내역 삭제 모달 */}
      </ModalThemeBridge>

      <ButtonWrapper>
        <SortButtonWrapper>
          <Button className='MemberShip' nowPage={nowPage} onClick={() => setNowPage('MemberShip')}>{t('memberDetail.tabMembership')}</Button>
          <Button className='Course' nowPage={nowPage} onClick={() => setNowPage('Course')}>{t('memberDetail.tabCourse')}</Button>
          <Button className='Product' nowPage={nowPage} onClick={() => setNowPage('Product')}>{t('memberDetail.tabProduct')}</Button>
          <Button className='Locker' nowPage={nowPage} onClick={() => setNowPage('Locker')}>{t('memberDetail.tabLocker')}</Button>
          <Button className='Point' nowPage={nowPage} onClick={() => setNowPage('Point')}>{t('memberDetail.tabPoint')}</Button>
        </SortButtonWrapper>
        <CreateButton ref={AddButtonRef} onClick={() => onClickAddMemberShipOrLockerButton()}>
          <StyledPlus  />
          {getButtonText()}
        </CreateButton>
      </ButtonWrapper>
      {
        nowPage === 'MemberShip' &&
        <InfoBox ref={MemberShipRef}>
          <MemberShipHistoryColumn />
          {
            failedSubscriptMemberships.map((data, index) => (
              <FailedSubscriptMembershipInfoView
                key={'FailedSubscriptMembership-' + index}
                ref={FailedHistoryButtonRef}
                size={failedSubscriptMemberships.length}
                data={data}
                index={index}
                retryClick={onClickSubscriptionRetry}
                deleteClick={onClickSubscriptionCancel} />
            ))
          }
          {
            useMemberShips.map((data, index) => (
              <MemberShipHistoryInfoView
                key={'Membership-' + index}
                ref={HistoryButtonRef}
                size={useMemberShips.length}
                data={data}
                index={index}

                firstExpiredIndex={firstExpiredIndex}

                modifyClick={memberShipModifyClick}
                holdingClick={memberShipHoldingClick}
                extensionClick={memberShipExtensionClick}
                refundClick={onClickRefundButton}
                subscriptionCancelClick={onClickSubscriptionCancel}
                deleteClick={memberShipDeleteClick}

                onClickHoldingAndExtendButton={onClickHoldingAndExtendButton}
                onClickHoldingEdit={onClickHoldingEdit}
                onClickDeleteHoldingHistory={onClickDeleteHoldingHistory}
                onClickModifyExtend={onClickModifyExtend}
                onClickDeleteExtend={onClickDeleteExtend}
                onClickRefundDelete={onClickRefundDelete}

                onClickDeleteExpectedUsage={onClickDeleteExpectedUsage} />
            ))
          }
        </InfoBox>
      }
      {
        nowPage === 'Subscription' &&
        <InfoBox>
          <SubscriptionColumnView />
        </InfoBox>
      }
      {
        nowPage === 'Course' &&
        <InfoBox ref={CourseRef} >
          <CourseHistoryColumnView />
          {
            useReserve.map((data, index) => (
              <CourseHistoryInfoView key={'Course-' + index} data={data} memberId={memberId} memberName={memberData?.name} rendering={rendering} />
            ))
          }
        </InfoBox>
      }
      {
        nowPage === 'Locker' &&
        <InfoBox ref={LockerRef}>
          <LockerHistoryColumnView />
          {
            useLocker.map((data, index) => (
              <LockerHistoryInfoView
                key={'Locker-' + index}
                data={data}
                index={index}
                size={useLocker.length}
                onClickLockerModify={onClickLockerModify}
                onClickLockerExtends={onClickLockerExtends}
                onClickLockerExit={onClickLockerExit}
                onClickLockerRefund={onClickLockerRefund}
                onClickDeleteLockerUsageHistory={onClickDeleteLockerUsageHistory}
                onClickModifyLockerRefund={onClickModifyLockerRefund}
                onClickDeleteLockerRefund={onClickDeleteLockerRefund}
                onClickDeleteExpectedLocker={onClickDeleteExpectedLocker}
                lockerRendering={lockerRendering} />
            ))
          }
        </InfoBox>
      }
      {
        nowPage === 'Product' &&
        <InfoBox>
          <ProductUsageColumn />
          {
            productUsages.map((data, index) => (
              <ProductUsageInfoView
                key={'Product' + index}
                data={data}
                onClickEditProductUsage={onClickEditProductUsage}
                onClickDeleteProductUsage={onClickDeleteProductUsage} />
            ))
          }
        </InfoBox>
      }
      {
        nowPage === 'Point' &&
        <InfoBox>
          <PointBoxWrapper>
            <PointBox>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='default'>{t('memberDetail.pointLabel') + totalPoint.toLocaleString('ko-KR')}</Text>
            </PointBox>
          </PointBoxWrapper>
          <PointHistoryColumn />
          {
            usePointHistories.map((data, index) => (
              <PointHistoryInfo
                key={'Point-' + index}
                data={data}
                index={index}
                onClickModify={onClickModifyPoint}
                onClickDelete={onClickDeletePoint} />
            ))
          }
        </InfoBox>
      }
      <PaginationWrapper>
        {nowPage === 'MemberShip' && <InfoPagination bottomMargin={96} nowPage={memberPage} totalPage={Math.ceil(memberShipData.length / 10)} prevClickFn={onClickMemberPrevPage} nextClickFn={onClickMemberNextPage} />}
        {nowPage === 'Course' && <InfoPagination bottomMargin={0} nowPage={reservePage} totalPage={Math.ceil(lessonHistoryData.length / 5)} prevClickFn={onClickReservePrevPage} nextClickFn={onClickReserveNextPage} />}
        {nowPage === 'Locker' && <InfoPagination bottomMargin={96} nowPage={lockerPage} totalPage={Math.ceil(lockerData.length / 10)} prevClickFn={onClickLockerPrevPage} nextClickFn={onClickLockerNextPage} />}
        {nowPage === 'Point' && <InfoPagination bottomMargin={96} nowPage={pointHistoryPage} totalPage={Math.ceil(pointHistories.length / 10)} prevClickFn={onClickPointHistoryPrevPage} nextClickFn={onClickPointHistoryNextPage} />}
      </PaginationWrapper>
      {
        nowPage === 'Course' &&
        <AttendanceBoxWrapper>
          <AttendanceCalenderBox lessonHistory={lessonHistoryData} />
          <AttendanceRateBox lessonHistory={lessonHistoryData} />
          <TotalAttendanceCountBox lessonHistory={lessonHistoryData} />
        </AttendanceBoxWrapper>
      }
    </TopLevelWrapper>
  )
})

export default HistoryView;

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 20px;
  margin-bottom: 96px;

  width: 970px;

  transition: all 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 40px;
`;

const SortButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;


  gap: 12px;
`;

const Button = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  padding: 0 20px;
  white-space: nowrap;

  box-sizing: border-box;
  height: 40px;

  border: ${props => props.nowPage === props.className ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.subBackground}`};
  border-radius: 11px;
  background-color: ${props => props.nowPage === props.className ? props.theme.primary : props.theme.subBackground};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.nowPage === props.className ? props.theme.subBackground : props.theme.subText};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }

  @media (hover: hover) {
    &:hover {
      font-family: NotoSansKR-Medium;
      color: ${props => props.theme.white};
      background-color: ${props => props.theme.primary};
      border: 1px solid ${props => props.theme.primary};
    }
  }
`;

const CreateButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0 20px;
  height: 40px;

  gap: 6px;

  border-radius: 11px;
  background-color: ${props => props.theme.subKey};

  white-space: nowrap;
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKeyHover};
  }
`;

const ModalThemeBridge = styled.div`
  ${props => props.theme.background === '#0F0F0F' && `
    input,
    textarea,
    select {
      background-color: ${props.theme.buttonFill} !important;
      border-color: ${props.theme.line} !important;
      color: ${props.theme.text} !important;
    }

    img[src*="BlackDeleteButton"],
    img[src*="GrayExitIcon"] {
      filter: invert(1);
    }
  `}
`;

const StyledPlus = styled(PlusSvg)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  path {
    fill: ${props => props.theme.subBackground};
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  min-height: 332px;

  gap: 8px;
  
  transition: all 0.3s ease-in-out;
`;

const PointBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin-top: 20px;
  
  width: 100%;
`;

const PointBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 162px;
  height: 38px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};
`;

const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  margin-top: 44px;
`;

const AttendanceBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 30px;

  width: 100%;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
